import { FC } from 'react';
import { Skeleton } from 'antd';
import classnames from 'classnames';
import useMobile from '@/hooks/useMobile';
import styles from './index.less';

const SkeletonLoading: FC = () => {
  const isMobile = useMobile();
  return (
    <div
      className={classnames([
        styles.c,
        {
          [styles['is-mobile']]: isMobile,
        },
      ])}
    >
      <div className={styles.leftC}>
        <Skeleton paragraph={{ rows: 2 }} active />
        <br />
        <br />
        <Skeleton paragraph={{ rows: 6 }} active />
        <br />
        <br />
        <Skeleton paragraph={{ rows: 2 }} active />
        <br />
        <br />
        <Skeleton paragraph={{ rows: 5 }} active />
      </div>
      <div className={styles.rightC}>
        <Skeleton paragraph={{ rows: 10 }} active />
      </div>
    </div>
  );
};

export default SkeletonLoading;
